module.exports = __webpack_public_path__ + "static/img/rix.9f357d9e.webp";